import React, { useState, useEffect } from "react";
import { Form, Row, Col, Button, Modal, Image } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import Axios from "axios";

//ACTIONS
import * as GS_navSettingsActions from "../../../../../store/actions/globalSettings/GS_navSettings";

//STYLES
import * as AlbumViewStyles from "../styles/albumView";

//COMPONENTS
import ImageSlot from "./imageSlot";
import UploadComponent from "../../../../mainStyle/components/uploadComponent/config";
import ImageViewer from "./imageViewer";

//IMAGES
import albumImage from "../Images/photoAlbumIcon.png";

function AlbumView() {
    const dispatch = useDispatch();
    const params = useParams();
    const [images, setImages] = useState([]);

    const moveModalDefaults = {
        open: false,
        currentAlbum: "",
        imageURL: "",
        albums: []
    };

    const [moveModal, setMoveModal] = useState(moveModalDefaults);

    function handleCloseMoveModal() {
        setMoveModal(moveModalDefaults);
    }

    const imageViewerDefaults = {
        open: false,
        imageURL: ""
    };

    const [imageViewer, setImageViewer] = useState(imageViewerDefaults);

    function handleVideoViewerClose() {
        setImageViewer(imageViewerDefaults);
    }

    function handleOpenMoveModal(currentAlbum, imageURL) {
        console.log(currentAlbum, imageURL);
        const data = { currentAlbum: currentAlbum };
        Axios.post("/pods/CPOD_PHOTOANDVIDEOGALLERY_ADMIN/move_loadPhotoAlbums", data)
            .then((res) => {
                const data = res.data;
                console.log(data);
                if (data.error == "null") {
                    setMoveModal((prevState) => {
                        return { ...prevState, currentAlbum, imageURL, albums: data.albums, open: true };
                    });
                }
            })
            .catch((err) => console.log(err));
    }

    function handleMoveModal_AlbumClick(album) {
        const data = { currentAlbum: moveModal.currentAlbum, newAlbum: album, imageURL: moveModal.imageURL };
        Axios.post("/pods/CPOD_PHOTOANDVIDEOGALLERY_ADMIN/moveImageToAnotherAlbum", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    setMoveModal(moveModalDefaults);
                    loadPhotos();
                }
            })
            .catch((err) => console.log(err));
    }

    useEffect(() => {
        dispatch(GS_navSettingsActions.UpdateTitle(`Photo And Video Gallery - ${params.name.replaceAll("_", " ")}`));
        dispatch(GS_navSettingsActions.UpdateSelected("Media"));
        dispatch(GS_navSettingsActions.UpdateSubSelected("Photo And Video Gallery"));

        loadPhotos();
    }, []);

    function loadPhotos() {
        const data = { album: params.name };
        Axios.post("/pods/CPOD_PHOTOANDVIDEOGALLERY_ADMIN/findAlbumPhotos", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    setImages(data.files);
                }
            })
            .catch((err) => console.log(err));
    }

    function handleNextFunction(reCallData, file) {
        loadPhotos();
    }

    function handleOpenImageViewer(imageURL) {
        setImageViewer((prevState) => {
            return { ...prevState, imageURL: imageURL, open: true };
        });
    }

    return (
        <div style={AlbumViewStyles.body}>
            <Row>
                <Col>
                    <UploadComponent
                        isImage={true}
                        fileType={"n/a"}
                        fileLimit={5}
                        fileSize={8}
                        multiple={false}
                        reCallData={null}
                        directoryPath={`photoAndVideoGallery/${params.name}`}
                        nextFunction={handleNextFunction}
                        showFileText
                        fileMessage={"Images only"}
                    />
                </Col>
            </Row>
            <br />
            <Row>
                {images.map((image, index) => {
                    return (
                        <Col md="auto" style={AlbumViewStyles.columnPadding} key={index}>
                            <ImageSlot
                                name={image}
                                album={params.name}
                                albumload={loadPhotos}
                                openMoveModal={handleOpenMoveModal}
                                openViewer={handleOpenImageViewer}
                            />
                        </Col>
                    );
                })}
            </Row>

            {/* MODALS */}
            <Modal size="lg" show={moveModal.open} onHide={handleCloseMoveModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Move</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {moveModal.albums.length == 0 ? (
                        <div style={AlbumViewStyles.move_noAblums}>There are no other photo albums to move it to</div>
                    ) : (
                        <div>
                            Select album to move the image to: <br /> <br />
                            <Row>
                                {moveModal.albums.map((album, index) => {
                                    return (
                                        <Col
                                            sm={4}
                                            key={index}
                                            style={AlbumViewStyles.albumBody}
                                            onClick={handleMoveModal_AlbumClick.bind(this, album)}
                                        >
                                            <div style={AlbumViewStyles.cardPicture}>
                                                <Image src={albumImage} style={AlbumViewStyles.albumImage} />
                                            </div>
                                            <div style={AlbumViewStyles.cardText}>{album.albumName.replace("_", " ")}</div>
                                        </Col>
                                    );
                                })}
                            </Row>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleCloseMoveModal}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
            <ImageViewer open={imageViewer.open} handleClose={handleVideoViewerClose} imageURL={imageViewer.imageURL} />
        </div>
    );
}

export default AlbumView;
